import { isInputObjectType, isSpecifiedScalarType } from "graphql";

function getMutationVarTypes(variableDefinitions, typeMap) {
  return variableDefinitions.reduce(function (vars, definition) {
    var typeInfo = definition.type.type || definition.type;
    var type = typeMap[typeInfo.name.value];
    return [].concat(vars, [type]);
  }, []);
}

function hasCreateVars(varTypes) {
  return varTypes.length === 1 && isInputObjectType(varTypes[0]);
}

function hasDeleteVars(varTypes) {
  return varTypes.length === 1 && isIdVar(varTypes[0]);
}

function hasUpdateVars(varTypes) {
  return varTypes.length === 2 && varTypes.reduce(function (hasUpdateVars, varType) {
    if (hasUpdateVars === false) return hasUpdateVars;
    return isInputObjectType(varType) || isIdVar(varType);
  }, null);
}

function isIdVar(varType) {
  return isSpecifiedScalarType(varType) && varType.name === "ID";
}

function resolveCreateMutation(args, table) {
  var input = args[Object.keys(args)[0]];
  return table.insert(input);
}

function resolveDeleteMutation(args, table) {
  var record = table.find(args.id);
  table.remove(args.id);
  return record;
}

function resolveUpdateMutation(args, table) {
  var input = args[Object.keys(args).find(function (arg) {
    return arg !== "id";
  })];
  return table.update(args.id, input);
}

function throwUnimplemented(info) {
  throw new Error("Could not find a default resolver for ".concat(info.fieldName, ". Please supply a resolver for this mutation."));
}

export function resolveMutation(args, context, info, typeName) {
  var collectionName = context.mirageSchema.toCollectionName(typeName);
  var table = context.mirageSchema.db[collectionName];
  var varTypes = getMutationVarTypes(info.operation.variableDefinitions, info.schema.getTypeMap());
  return hasCreateVars(varTypes) ? resolveCreateMutation(args, table) : hasDeleteVars(varTypes) ? resolveDeleteMutation(args, table) : hasUpdateVars(varTypes) ? resolveUpdateMutation(args, table) : throwUnimplemented(info);
}
